<script lang="ts">
import { iIcon } from '@inscribe/signal';
import { PropType, ref } from 'vue';

export type RiskLevelFilter = {
  id: string;
  title: string;
  subtitle: string;
  icon: string;
  queryParam: string;
  label: string;
};

export default {
  name: 'RiskFilterButton',
  components: { iIcon },
  props: {
    filter: {
      type: Object as PropType<RiskLevelFilter>,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    return {
      hoverState: ref(false),
    };
  },
  methods: {
    onFilterClick() {
      this.$emit('filter-click', this.filter);
    },
  },
};
</script>

<template>
  <button
    :class="{ selected }"
    class="button-filter d-flex flex-row align-items-center i-radius-xl i-px-9 i-py-6 i-gap-8"
    @click="onFilterClick"
  >
    <i-icon :symbol="filter.icon" :size="16" />
    <div class="d-flex flex-column align-items-start">
      <span class="title i-text-subheading-2">{{ filter.title }}</span>
      <span class="subtitle i-text-body-3">{{ filter.subtitle }}</span>
    </div>
  </button>
</template>

<style lang="scss" scoped>
.button-filter {
  background: var(--base);
  border: 1px solid var(--border-neutral-subtle);
  transition: all 150ms ease-in-out;

  &:hover,
  &.selected {
    background: var(--surface-neutral-subtle);
    border: 1px solid var(--border-neutral-bold);

    .i-icon {
      color: var(--icon-neutral);
    }
  }

  .title {
    color: var(--text-neutral-bold);
    white-space: nowrap;
  }

  .subtitle {
    color: var(--text-neutral);
    white-space: nowrap;
  }

  .i-icon {
    color: var(--icon-neutral-subtle);
  }
}
</style>
